<template>
  <div
    class="model-container"
    :id="content.key"
  >
    <styleType1 v-if="styleType === 1" contentType="3D" :content="content" @dialogOpen="dialogVisible = true"></styleType1>
    <template v-else>
      <el-image
        class="model-image"
        :id="`${content.key}-1`"
        :src="content.cover"
        :style="{
          width: canSetWidth ? content.width : ''
        }"
        @click.stop="dialogVisible = true"
      ></el-image>
      <p
        class="model-title"
        :id="`${content.key}-2`"
        :style="{
          fontFamily: content.titleStyle.fontFamily || '',
          fontSize: (content.titleStyle.fontSize + 'px') || '',
          lineHeight: (content.titleStyle.lineHeight + 'px') || '',
          textIndent: (typeof content.titleStyle.textIndent === 'string') ? content.titleStyle.textIndent :
            (typeof content.titleStyle.textIndent === 'number') ? (content.titleStyle.textIndent + 'rem') : '',
          fontWeight: content.titleStyle.fontWeight || '',
          textDecoration: content.titleStyle.underline === 1 ? 'underline' : '',
          fontStyle: content.titleStyle.fontItalic === 1 ? 'italic' : '',
          textAlign: content.titleStyle.textAlign || '',
          color: content.titleStyle.color || '',
          backgroundColor: content.titleStyle.backgroundColor || '',
        }"
      >{{ content.title }}</p>
    </template>
    <threeDPopup
      :dialogTitle="dialogTitle"
      :dialogVisible="dialogVisible"
      :iframeUrl="content.url"
      :showInFullPage="true"
      :showInNewPage="true"
      @dialogClose="dialogClose"
    ></threeDPopup>
  </div>
</template>

<script>
/*
单个三维模型样式
*/
import threeDPopup from "../../popup/threeD.vue";
import styleType1 from "../style/style-1.vue";
export default {
  name: "threeDUnit",
  components: {
    threeDPopup,
    styleType1,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
    styleType: {
      type: Number,
      default: 0
    },
    canSetWidth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogTitle: '',
      dialogVisible: false
    }
  },
  methods: {
    dialogClose() {
      this.dialogVisible = false;
    },
  }
}
</script>

<style lang="scss" scoped>
.model-container {

  .model-image{
    width: 100%;
    height: auto;
    display: block;
    margin: 0 auto 10px;
  }

  .model-title{
    display: block;
    margin-bottom: 10px;
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: #00a8ac;
  }
}
</style>